import axios from 'axios'
import { uri } from '../help/Api'
import { sto } from '../Context/InshData';

export const URL =uri+'Omlat';

export function list(){
    return axios.get(URL);
}

export function create(data){
    return axios.post(URL, data);
}

export function update(data){
    return axios.put(URL, data)
}
export function remove(id){
    let Urls = null;
    if (sto.db_name === "" || sto.db_name === null) {
      Urls = `Omlat?id=${id}`
    } else {
      Urls = `Omlat?id=${id}&&db_name=${sto?.db_name}`
    }
    // return axios.delete(URL+`/${id}`)
    return axios.delete(uri+Urls)
}

export default{list, create, update, remove}